export default __webpack_public_path__ + "static/media/walkThrough007.4b75f10d.png";